var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaScreeningDekubitusrisikofaktoren(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10{fill:none;}.cls-2{fill:#fff;}.cls-3{fill:#ea5c0b;}.cls-4{fill:#309eed;}.cls-5{fill:#76b72a;}.cls-6,.cls-9{fill:#c7cfe2;}.cls-7{fill:#59667c;}.cls-8{fill:#3b485e;}.cls-9{opacity:0.25;}.cls-10{stroke:#3b485e;stroke-miterlimit:10;stroke-width:3.6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.89,16.64A8.64,8.64,0,0,1,28.53,8H91.89l36,30.24V143.36a8.64,8.64,0,0,1-8.64,8.64H28.53a8.64,8.64,0,0,1-8.64-8.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 34.66,
    y: 33.92,
    width: 25.82,
    height: 26.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 34.66,
    y: 73.39,
    width: 25.82,
    height: 26.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 34.66,
    y: 112.87,
    width: 25.82,
    height: 26.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.89,8V29.6a8.64,8.64,0,0,0,8.64,8.64h27.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M107.64,46.74A2.26,2.26,0,0,1,105.39,49H71.64a2.25,2.25,0,0,1-2.25-2.25h0a2.26,2.26,0,0,1,2.25-2.25h33.75a2.27,2.27,0,0,1,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.14,58a2.26,2.26,0,0,1-2.25,2.25H71.64A2.25,2.25,0,0,1,69.39,58h0a2.26,2.26,0,0,1,2.25-2.25H91.89A2.27,2.27,0,0,1,94.14,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M107.64,86.75A2.26,2.26,0,0,1,105.39,89H71.64a2.25,2.25,0,0,1-2.25-2.25h0a2.25,2.25,0,0,1,2.25-2.25h33.75a2.26,2.26,0,0,1,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.14,98a2.26,2.26,0,0,1-2.25,2.25H71.64A2.25,2.25,0,0,1,69.39,98h0a2.25,2.25,0,0,1,2.25-2.25H91.89A2.26,2.26,0,0,1,94.14,98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M107.64,126.76a2.27,2.27,0,0,1-2.25,2.25H71.64a2.26,2.26,0,0,1-2.25-2.25h0a2.25,2.25,0,0,1,2.25-2.25h33.75a2.26,2.26,0,0,1,2.25,2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.14,138a2.27,2.27,0,0,1-2.25,2.25H71.64A2.26,2.26,0,0,1,69.39,138h0a2.25,2.25,0,0,1,2.25-2.25H91.89A2.26,2.26,0,0,1,94.14,138Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111.25,108.38l-3.93,3.93-4.89-4.89c.72-.59,1.43-1.19,2-1.78a14.38,14.38,0,0,0,1.78-2Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 87.18,
    cy: 87.8,
    rx: 22.4,
    ry: 23.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M141.27,137.92,137,142.21a2.31,2.31,0,0,1-3.34,0L107.2,115.76a2.28,2.28,0,0,1,0-3.33l4.29-4.29a2.28,2.28,0,0,1,3.33,0l26.33,26.33A2.57,2.57,0,0,1,141.27,137.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 118.83,
    y: 108.75,
    width: 10.72,
    height: 32.76,
    transform: "translate(-52.11 124.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 87.18,
    cy: 88.12,
    r: 24.66
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaScreeningDekubitusrisikofaktoren);
export default __webpack_public_path__ + "static/media/ka_screening_dekubitusrisikofaktoren.8702384127136cdd51417e2d74213962.svg";
export { ForwardRef as ReactComponent };